import { HoldAuditType, HoldReaction, HoldStatus } from '@planning/app/api'
import { ColorSchema } from 'modules/ui/src/theme/palette'

export const getHoldAuditEventLabel = (type: HoldAuditType | undefined) => {
  switch (type) {
    case HoldAuditType.Create:
      return { on: 'Created on', by: 'Created by' }
    case HoldAuditType.Update:
      return { on: 'Updated on', by: 'Updated by' }
    case HoldAuditType.Approve:
      return { on: 'Approved on', by: 'Approved by' }
    case HoldAuditType.Override:
      return { on: 'Overridden on', by: 'Overridden by' }
    default:
      return { on: 'On', by: 'By' }
  }
}

export const getReactionColor = (reactionType: HoldReaction | string): ColorSchema =>
  reactionType === 'Block' ? 'error' : 'warning'

export const getHoldStatusColor = (status: HoldStatus | string | undefined): ColorSchema => {
  if (status === 'Active') return 'warning'
  if (status === 'Resolved') return 'success'
  return 'secondary'
}
